import jwt_decode from "jwt-decode";
import sign from "jwt-encode";
import router from "../router";
import moment from "moment";
import axios from "axios";
import apiUrl from "./apiUrl";
// import vuetify from '@/plugins/vuetify'; // Assuming you have a vuetify plugin

const tempAxios = axios.create({
  baseURL: process.env.VUE_APP_MICROSERIVICE_URL,
});

const is_token_valid = () => {
  let date = new Date().getTime() / 1000;
  let access = localStorage.getItem("access");
  let refresh = localStorage.getItem("refresh");
  if (access && refresh) {
    let decode_access = jwt_decode(access);
    let decode_refresh = jwt_decode(refresh);
    if (decode_access.exp > date) {
      return true;
    } else if (decode_refresh.exp > date) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};
export const isAuthenticated = () => {
  const id = localStorage.getItem("user_id");
  const verified = localStorage.getItem("verified");
  // const token = localStorage.getItem('token')
  const profile_id = localStorage.getItem("profile_id");
  if (!is_token_valid()) {
    return false;
  }
  return id && verified && profile_id;
};

export const getImgLink = (link) => {
  if (link.split(":")[0] === "https" || link.split(":")[0] === "http") {
    return link;
  }
  return `https://api.covesto.in${link}`;
};

export const logout = () => {
  localStorage.removeItem("user_id");
  localStorage.removeItem("verified");
  localStorage.removeItem("access");
  localStorage.removeItem("refresh");
  localStorage.clear();
  sessionStorage.removeItem("session");
  sessionStorage.clear();
  this.$store.state.Auth.checkStatus = "LOGIN";
  this.$store.state.isPrivate = false;
  this.$store.state.Auth.flagVerified = false;
  this.$router.push({ name: "login" });
};

export const getToken = () => {
  let date = new Date().getTime() / 1000;
  let access = localStorage.getItem("access");
  let refresh = localStorage.getItem("refresh");
  let decode_access = jwt_decode(access);
  let decode_refresh = jwt_decode(refresh);
  if (is_token_valid) {
    if (decode_access.exp > date) {
      return access;
    } else if (decode_refresh.exp > date) {
      return refresh;
    }
  } else {
    localStorage.removeItem("user_id");
    localStorage.removeItem("verified");
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");
    localStorage.clear();
    sessionStorage.removeItem("session");
    sessionStorage.clear();
    this.$store.state.Auth.checkStatus = "LOGIN";
    this.$store.state.isPrivate = false;
    this.$store.state.Auth.flagVerified = false;
    // this.$router.push({ name: "AuthPage" });
    router.push({ name: "AuthPage" });
  }
};

export default {
  getProfileId() {
    return parseInt(localStorage.getItem("profile_id"));
  },
  getUserId() {
    return parseInt(localStorage.getItem("user_id"));
  },
  isSuperUser() {
    if (localStorage.getItem("is_superuser")) {
      let is_superuser = JSON.parse(localStorage.getItem("is_superuser"));
      return is_superuser;
    } else {
      return false;
    }
  },
  getFormattedDate(date) {
    return moment(date).format("DD-MMM-YYYY");
  },
  decode_smallcase_authtoken_and_send(tranxResponse, trade_id, trade_actions) {
    console.log(tranxResponse, trade_id, trade_actions);
    const { smallcaseAuthToken, transactionId, orderBatches } = tranxResponse;
    // orderBatches[0].batchId
    let decoded_token = jwt_decode(smallcaseAuthToken);
    const { smallcaseAuthId } = decoded_token;
    let config = {};
    let params = {};
    params["trade_id"] = trade_id;
    params["transaction_id"] = transactionId;
    params["batch_id"] = orderBatches[0].batchId;
    params["auth_id"] = smallcaseAuthId;
    params["trade_action"] = trade_actions;

    config["params"] = params;

    tempAxios
      .patch(apiUrl.TRADE_DETAIL, {}, config)
      .then((res) => {
        console.log(res, "saved details to microservice");
      })
      .catch((error) => {
        console.log(error, "error saving detail to microservice");
      });
  },
  showOrder(authToken) {
    const gatewayInstance = new window.scDK({
      // ! Use valid gateway name here
      gateway: "covesto",
      /*
       * ! Use valid auth token
       * Details - https://developers.gateway.smallcase.com/docs/getting-started#broker-identification
       */
      smallcaseAuthToken: authToken,
      config: {
        // Should allow after market orders?
        amo: true,
      },
    });
    gatewayInstance
      .showOrders()
      .then((res) => {
        console.log("sdk res", res);
      })
      .catch((err) => {
        console.log("err", err);
      });
  },
  getAuthId(tranxResponse) {
    const { smallcaseAuthToken } = tranxResponse;
    let decoded_token = jwt_decode(smallcaseAuthToken);
    const { smallcaseAuthId } = decoded_token;
    return smallcaseAuthId;
  },
  IsAuth() {
    let date = new Date().getTime() / 1000;
    let access = localStorage.getItem("access");
    let refresh = localStorage.getItem("refresh");
    if (access && refresh) {
      let decode_access = jwt_decode(access);
      let decode_refresh = jwt_decode(refresh);
      if (decode_access.exp > date) {
        return true;
      } else if (decode_refresh.exp > date) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  },
  logout() {
    localStorage.removeItem("user_id");
    localStorage.removeItem("verified");
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");
    localStorage.clear();
    sessionStorage.removeItem("session");
    sessionStorage.clear();
    //  GA events
    window.dataLayer.push({ event: "user_successfully_logout" });

    const viewportWidth = window.innerWidth;
    const isMobileView = viewportWidth < 768;

    if (isMobileView) {
      window.dataLayer.push({ event: "mweb_user_successfully_logout" });
    }
    router.push({ name: "login", query: { logout: true } });
  },
  redirectToLogin() {
    router.push({ name: "AuthPage" });
  },
  encodeData(data) {
    const secret = "covesto_user_id_82055795-7bd7";
    const jwt = sign(data, secret);
    return jwt;
  },
};
